import type { A11yPrefs, ControlConfig } from './types'

export const DEFAULT_PREFS: A11yPrefs = {
  widgetEnabled: false,
  textSize: 'default',
  cursorSize: 'default',
  contrast: 'off',
  motion: 'on',
  dyslexia: 'off',
  focus: 'default',
}

export const CYCLE_NEXT = {
  textSize: { default: 'large', large: 'xlarge', xlarge: 'default' },
  cursorSize: { default: 'large', large: 'xlarge', xlarge: 'default' },
  contrast: { off: 'on', on: 'off' },
  motion: { on: 'reduced', reduced: 'on' },
  dyslexia: { off: 'on', on: 'off' },
  focus: { default: 'enhanced', enhanced: 'default' },
} as const

export const STATE_LABELS: Record<string, Record<string, string>> = {
  textSize: {
    default: 'Default',
    large: 'Large',
    xlarge: 'XLarge',
  },
  cursorSize: {
    default: 'Default',
    large: 'Large',
    xlarge: 'XLarge',
  },
  contrast: {
    off: 'Off',
    on: 'On',
  },
  motion: {
    on: 'On',
    reduced: 'Reduced',
  },
  dyslexia: {
    off: 'Off',
    on: 'On',
  },
  focus: {
    default: 'Default',
    enhanced: 'Enhanced',
  },
}

export const CONTROL_CONFIG: ControlConfig[] = [
  {
    key: 'textSize',
    label: 'Text Size',
    iconName: 'Type',
    states: ['default', 'large', 'xlarge'],
  },
  {
    key: 'cursorSize',
    label: 'Cursor Size',
    iconName: 'MousePointer2',
    states: ['default', 'large', 'xlarge'],
  },
  {
    key: 'contrast',
    label: 'Contrast',
    iconName: 'Contrast',
    states: ['off', 'on'],
  },
  {
    key: 'motion',
    label: 'Motion',
    iconName: 'Zap',
    states: ['on', 'reduced'],
  },
  {
    key: 'dyslexia',
    label: 'Dyslexia Font',
    iconName: 'BookOpen',
    states: ['off', 'on'],
  },
  {
    key: 'focus',
    label: 'Focus',
    iconName: 'Focus',
    states: ['default', 'enhanced'],
  },
]
